import React, {useState} from 'react'
import {
  Button, Box, Flex, FlexBetween, TextField, Text, Loading, Slider
} from '@binance/uikit'
import {SETTING} from 'constants'
import {
  onInputChange, onKeyPress, onBlur, onKeyDown
} from 'utils/limitInput'
import {getPowOf} from 'utils/common'

const StopLimitForm: React.FunctionComponent = ({
  i18n,
  isLogin,
  requireLoginEl,
  baseAsset,
  quoteAsset,
  pricePrecision,
  quantityPrecision,
  maxLen,
  buyStopPrice,
  buyPrice,
  buyQty,
  maxPrice,
  limitMaxQty,
  sellStopPrice,
  sellPrice,
  sellQty,
  orderBuyValue,
  marginBuyRequired,
  orderSellValue,
  marginSellRequired,
  handleStopPriceChange,
  handlePriceChange,
  handleQtyChange,
  handleBuy,
  handleSell,
  buyStatus,
  sellStatus,
  buyAvailableRange,
  sellAvailableRange,
  changeSliderValue
}) => {
  const [sliderBuyQty, setSliderBuyQty] = useState(0)
  const [sliderSellQty, setSliderSellQty] = useState(0)
  return (
    <React.Fragment>
      <Flex mx={5}>
        <Box mr={5} flex="1">
          <Box mb={5}>
            <TextField
              type="text"
              value={buyStopPrice}
              step={getPowOf(pricePrecision)}
              min="0"
              max={maxPrice}
              onKeyPress={e => onKeyPress(e, maxLen)}
              handleChange={e => onInputChange(e, handleStopPriceChange, 'buy', pricePrecision)}
              onBlur={e => onBlur(e)}
              before={<Text.Caption width={70}>{i18n.stopPriceTitle || 'Stop Price'}</Text.Caption>}
              after={<Text.Caption>{quoteAsset}</Text.Caption>}
              style={{textAlign: 'right'}}
            />
            <TextField
              type="text"
              value={buyPrice}
              step={getPowOf(pricePrecision)}
              min="0"
              max={maxPrice}
              onKeyPress={e => onKeyPress(e, maxLen)}
              handleChange={e => onInputChange(e, handlePriceChange, 'buy', pricePrecision)}
              onBlur={e => onBlur(e)}
              before={<Text.Caption width={70}>{i18n.priceTitle || 'Price'}</Text.Caption>}
              after={<Text.Caption>{quoteAsset}</Text.Caption>}
              style={{textAlign: 'right'}}
            />
            <TextField
              type="text"
              value={buyQty}
              step={getPowOf(quantityPrecision)}
              min="0"
              max={limitMaxQty}
              onKeyPress={e => onKeyPress(e, maxLen)}
              handleChange={e => {
                setSliderBuyQty(0)
                onInputChange(e, handleQtyChange, 'buy', quantityPrecision)
              }}
              onBlur={e => onBlur(e)}
              onKeyDown={e => onKeyDown(e, handleBuy)}
              before={<Text.Caption width={70}>{i18n.orderQtyTitle || 'Order Qty'}</Text.Caption>}
              after={<Text.Caption>{baseAsset}</Text.Caption>}
              style={{textAlign: 'right'}}
            />
            <Box px={4}>
              {
                SETTING.slideFlag
                  ? <Slider
                    color={'#00C087'}
                    bgColor={'#2A2F37'}
                    pointColor={'#48515D'}
                    progress={sliderBuyQty}
                    changedProgress={sliderBuyQty}
                    onChange={val => {
                      typeof changeSliderValue === 'function' && changeSliderValue({val, type: 'buy', places: quantityPrecision})
                      setSliderBuyQty(val)
                    }}
                    stepSize={4}
                    unit={'%'}
                    range={{min: 0, max: 100}}
                    showScales={false}
                    availableRange={buyAvailableRange}
                  />
                  : null
              }
            </Box>
          </Box>
          <Box>
            <FlexBetween
              height="16px"
              before={
                <Text.Caption width={120}>{i18n.marginRequired || 'Margin Required'}</Text.Caption>
              }
              text={marginBuyRequired}
              after={<Text.Caption display="inline-block">{quoteAsset}</Text.Caption>}
            />
            <FlexBetween
              height="16px"
              before={<Text.Caption width={70}>{i18n.orderValue || 'Order Value'}</Text.Caption>}
              text={orderBuyValue}
              after={<Text.Caption display="inline-block">{quoteAsset}</Text.Caption>}
            />
          </Box>

          {isLogin ? (
            <Button ml={0} bg="green" width="100%" onClick={handleBuy} disabled={buyStatus}>
              {i18n.buyLong || 'Buy/Long'}
            </Button>
          ) : isLogin === false ? (
            requireLoginEl
          ) : (
            <Flex height={40}>
              <Loading />
            </Flex>
          )}
        </Box>

        <Box flex="1">
          <Box mb={5}>
            <TextField
              type="text"
              value={sellStopPrice}
              step={getPowOf(pricePrecision)}
              min="0"
              max={maxPrice}
              onKeyPress={e => onKeyPress(e, maxLen)}
              handleChange={e => onInputChange(e, handleStopPriceChange, 'sell', pricePrecision)}
              onBlur={e => onBlur(e)}
              before={<Text.Caption width={70}>{i18n.stopPriceTitle || 'Stop Price'}</Text.Caption>}
              after={<Text.Caption>{quoteAsset}</Text.Caption>}
              style={{textAlign: 'right'}}
            />
            <TextField
              type="text"
              value={sellPrice}
              step={getPowOf(pricePrecision)}
              min="0"
              max={maxPrice}
              onKeyPress={e => onKeyPress(e, maxLen)}
              handleChange={e => onInputChange(e, handlePriceChange, 'sell', pricePrecision)}
              onBlur={e => onBlur(e)}
              before={<Text.Caption width={70}>{i18n.priceTitle || 'Price'}</Text.Caption>}
              after={<Text.Caption>{quoteAsset}</Text.Caption>}
              style={{textAlign: 'right'}}
            />
            <TextField
              type="text"
              value={sellQty}
              step={getPowOf(quantityPrecision)}
              min="0"
              max={limitMaxQty}
              onKeyPress={e => onKeyPress(e, maxLen)}
              handleChange={e => {
                setSliderSellQty(0)
                onInputChange(e, handleQtyChange, 'sell', quantityPrecision)
              }}
              onBlur={e => onBlur(e)}
              onKeyDown={e => onKeyDown(e, handleBuy)}
              before={<Text.Caption width={70}>{i18n.orderQtyTitle || 'Order Qty'}</Text.Caption>}
              after={<Text.Caption>{baseAsset}</Text.Caption>}
              style={{textAlign: 'right'}}
            />
            <Box px={4}>
              {
                SETTING.slideFlag
                  ? <Slider
                    color={'#EA0070'}
                    bgColor={'#2A2F37'}
                    pointColor={'#48515D'}
                    progress={sliderSellQty}
                    changedProgress={sliderSellQty}
                    onChange={val => {
                      typeof changeSliderValue === 'function' && changeSliderValue({val, type: 'sell', places: quantityPrecision})
                      setSliderSellQty(val)
                    }}
                    stepSize={4}
                    unit={'%'}
                    range={{min: 0, max: 100}}
                    showScales={false}
                    availableRange={sellAvailableRange}
                  /> : null
              }
            </Box>
          </Box>
          <Box>
            <FlexBetween
              height="16px"
              before={
                <Text.Caption width={120}>{i18n.marginRequired || 'Margin Required'}</Text.Caption>
              }
              text={marginSellRequired}
              after={<Text.Caption display="inline-block">{quoteAsset}</Text.Caption>}
            />
            <FlexBetween
              height="16px"
              before={<Text.Caption width={70}>{i18n.orderValue || 'Order Value'}</Text.Caption>}
              text={orderSellValue}
              after={<Text.Caption display="inline-block">{quoteAsset}</Text.Caption>}
            />
          </Box>
          {isLogin ? (
            <Button ml={0} bg="pink" width="100%" onClick={handleSell} disabled={sellStatus}>
              {i18n.sellShort || 'Sell/Short'}
            </Button>
          ) : isLogin === false ? (
            requireLoginEl
          ) : (
            <Flex height={40}>
              <Loading />
            </Flex>
          )}
        </Box>
      </Flex>
    </React.Fragment>
  )
}

export default StopLimitForm
